export default __webpack_public_path__ + "static/champion-htf-middleweight-webfont-7982ac513ca3327b15f20794a610ec51.woff";